
import { getBytesCount } from '@utils/data';


const validateCategoryIds = (rule, value, callback) => {
    if (value.length === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateShopAddress = (rule, value, callback) => {
    if (!value[0] || !value[1] || !value[2]) {
        callback(new Error('请选择发货地址'));
    } else {
        callback();
    }
}

const validateStock = (rule, value, callback) => {
    if (value === 0) {
        callback(new Error('库存数需要大于0'));
    } else {
        callback();
    }
}

const validateTitle = (rule, value, callback, context) => {
    if (getBytesCount(value) > 60) {
        callback(new Error('字符数不能超过60'))
    } else {
        callback();
    }
}
const validateImages = async (rule, value, callback, context) => {
    let errMsg = await context.$refs.images.method_validImage()
    if (errMsg) {
        callback(new Error(errMsg));
    } else {
        callback();
    }

}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context) {
    return (rule, value, callback) => fn(rule, value, callback, context)
}

const RULES = function (context) {
    return {
        categoryIds: [
            { required: true, message: '请选择类目' },
            { validator: validateCategoryIds }
        ],
        images: [
            { required: true, message: '至少选择1张图片' },
            { validator: contextWrap(validateImages, context) }
        ],
        shopAddress: [
            { required: true, message: '请选择发货地' },
            { validator: validateShopAddress }
        ],
        content: [
            { required: true, message: '商品描述必填' },
        ],
        title: [
            { required: true, message: '请输入商品标题' },
            { validator: contextWrap(validateTitle, context) },
        ],

        price: [
            { required: true, message: '必填' },
        ],
        stock: [
            { required: true, message: '必填' },
            { validator: validateStock }
        ],
        stuffStatus: [
            { required: true, message: '必填' },
        ],
    };
}


export {
    RULES as default,
}
